import React from 'react';
import styled, { css } from 'styled-components';

import { basic, grey } from '../../theme/colors';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode | React.ReactNode[];
  variant?: string;
  isActive?: boolean;
}

const basicStyle = {
  outline: 'none',
  zIndex: '9',
  padding: '0',
  border: 'none',
  borderRadius: '4px',
  height: '80px',
  width: '80px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: '150ms linear all',
} as const;

const variantStyles = (variant?: string) =>
  variant &&
  {
    geolocate: css`
      width: 56px;
      height: 56px;
      right: 24px;
      bottom: 24px;
      background: #ffffff;
      position: absolute;
      border: 0.6px solid ${basic.haydenBorder};
    `,
  }[variant];

export const MapButton = styled.button<Props>`
  ${basicStyle}
  ${({ isActive }) =>
    isActive &&
    css`
      box-shadow: ${grey.haydenGreyShade4} 0px 1px 4px
    `}

  ${({ variant }) => variantStyles(variant)}
`;
